import {
  ADD_PROPERTY,
  UPDATE_PROPERTY,
  DELETE_PROPERTY,
  CANCEL_REQUEST,
  CLEAR_PROPERTY_ACTION,
  CLEAR_CREATE_ACTION,
  FETCH_PROPERTY_TYPES,
  UPLOAD_PROPERTY_TYPES,
  FETCH_SCHEMA,
  UPDATE_SCHEMA,
  CLEAR_MAINTENANCE,
  FETCH_CATEGORIES,
  ADD_CATEGORIES,
  UPDATE_CATEGORIES,
  FETCH_WORKORDERS,
  FETCH_OPEN_WORKORDERS,
  ADD_WORKORDERS,
  GET_WORKORDER,
  ADD_MAINTENANCE,
  FETCH_ALL_TYPES,
  UPLOAD_TYPES,
  FETCH_ALL_LOCATIONS,
  CLEAR_TENANT_TYPES
} from './types';

const BACKEND_API = 'BACKEND_API';

export const addProperty = data => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: '/lease_properties/',
    data,
    ...ADD_PROPERTY
  }
});

export const updateProperty = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'patch',
    url: `/lease_properties/${id}/`,
    data,
    ...UPDATE_PROPERTY
  }
});

export const cancelRequest = (publicUrl, id, data, airportCode) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    url: `${publicUrl}/non_airfield/update_status/${id}/${airportCode}`,
    data,
    ...CANCEL_REQUEST
  }
});

export const deleteProperty = id => ({
  type: BACKEND_API,
  payload: {
    method: 'delete',
    url: `/lease_properties/${id}/`,
    ...DELETE_PROPERTY
  }
});

export const fetchPropertyTypes = () => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'get',
      url: '/lease_properties/get_property_types/'
    },
    FETCH_PROPERTY_TYPES
  )
});

export const uploadPropertyTypes = data => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: '/lease_properties/upload_property_types/',
    data,
    ...UPLOAD_PROPERTY_TYPES
  }
});

//  Fetching Schema used to create a workorder
export const fetchWorkOrderSchema = () => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'get',
      url: '/portal_maintenance/get_schema'
    },
    FETCH_SCHEMA
  )
});

export const updateWorkOrderSchema = data => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: '/lease_work_orders/update_schemas/',
    data,
    ...UPDATE_SCHEMA
  }
});

//  Fetching Categories for creating Non Airfield Workorder
export const fetchCategories = () => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'get',
      url: '/portal_maintenance/get_categories/'
    },
    FETCH_CATEGORIES
  )
});

export const addCategory = data => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'post',
      url: '/maintenance_categories/',
      data,
      ...ADD_CATEGORIES
    }
  )
});

export const updateCategory = (id, data) => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'patch',
      url: `/maintenance_categories/${id}/`,
      data,
      ...UPDATE_CATEGORIES
    }
  )
});

export const fetchLeaseWorkorders = created_by_me => ({
  type: BACKEND_API,
  payload:
      {
    method: 'GET',
    url: `/portal_maintenance/?${created_by_me ? 'created_by_me=' : ''}${created_by_me || ''}`,
    ...FETCH_WORKORDERS
  }
}
);

//  Action to create a work order
export const createLeaseWokrorder = data => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: '/portal_maintenance/create_workorder/',
    data,
    ...ADD_WORKORDERS
  }
});

export const fetchOpenWorkorders = (publicUrl, data, airportCode) => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: `${publicUrl}/non_airfield/get_workorders_by_location/${airportCode}`,
    data,
    ...FETCH_OPEN_WORKORDERS
  }
});

export const getLeaseWorkorder = id => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/portal_maintenance/${id}`,
    ...GET_WORKORDER
  }
});

export const createLeaseMaintenance = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: `/lease_work_orders/${id}/maintenance_review/`,
    data,
    ...ADD_MAINTENANCE
  }
});

export const fetchAllTypes = () => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: '/lease_tenants/get_types/',
    ...FETCH_ALL_TYPES
  }
});

export const uploadTypes = data => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: '/lease_tenants/upload_types/',
    data,
    ...UPLOAD_TYPES
  }
});

export const fetchLocations = locationsonly => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/portal/get_locations/${locationsonly? '?nawo=true': ''}`,
    ...FETCH_ALL_LOCATIONS
  }
});

export const clear = () => ({
  type: CLEAR_PROPERTY_ACTION
});

export const clearCreateAction = () => ({
  type: CLEAR_CREATE_ACTION
});

export const clearMaintenance = () => ({
  type: CLEAR_MAINTENANCE
});

export const clearTenantsTypes = () => ({
  type: CLEAR_TENANT_TYPES
});
